// extracted by mini-css-extract-plugin
export default {"buttons-view":"buttons-view__YlZgF"};